import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Bell } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import { getDopamineCopy } from '../i18n/dopamine';

export const DopamineSpotlight = () => {
  const { lang } = useLang();
  const c = getDopamineCopy(lang);
  return (
    <section className="relative bg-[#141c14] overflow-hidden" data-testid="dopamine-spotlight">
      <div className="absolute -top-32 -right-32 w-[30rem] h-[30rem] rounded-full bg-[#aebf9f]/10 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-20 grid md:grid-cols-2 gap-10 items-center">
        <div className="reveal">
          <span className="inline-flex items-center gap-2 px-3 py-1 border border-[#aebf9f]/40 text-[#aebf9f] text-[0.62rem] tracking-[0.3em] uppercase">{c.soon}</span>
          <p className="mt-6 font-serif text-[0.85rem] tracking-[0.5em] uppercase text-ivory/60">D O P A M I N E</p>
          <h2 className="mt-3 font-serif text-3xl md:text-5xl text-ivory leading-tight">{c.hT}</h2>
          <p className="mt-4 text-ivory/70 leading-relaxed max-w-md">{c.hP}</p>
          <Link to="/dopamine" data-testid="dopamine-spotlight-cta"
            className="mt-8 inline-flex items-center gap-3 px-8 py-3.5 bg-[#aebf9f] text-[#141c14] text-xs tracking-[0.2em] uppercase font-semibold hover:bg-[#cfd9c3] transition-colors">
            <Bell className="w-4 h-4" /> {c.hCta} <ArrowRight className="w-4 h-4 rtl:rotate-180" />
          </Link>
        </div>
        <div className="reveal relative hidden md:block">
          <div className="absolute inset-4 border border-[#aebf9f]/20" />
          <img src="https://www.dopamine.org.tr/assets/product-duo.png" alt="DOPAMINE scalp serums — coming soon"
            loading="lazy" className="relative w-full max-h-[380px] object-cover" />
        </div>
      </div>
    </section>
  );
};

export default DopamineSpotlight;
